import { useMutation, useQuery, useQueryClient } from 'react-query';
import { calledClient, get1688Deliveries } from './api';

export const use1688DeliveriesList = (currentPage, trackCode, country) => {
    const { data, isLoading, isError, isSuccess, error } = useQuery(
        ['1688-deliveries', currentPage, trackCode],
        () => get1688Deliveries(currentPage, trackCode, country).then((res) => res.data),
    );

    return {
        deliveries: data || [],
        isLoading,
        isError,
        isSuccess,
        error,
    };
};

export const useCalledClient = () => {
    const queryClient = useQueryClient();

    const { mutate, isLoading } = useMutation(
        ['calledClient'],
        (trackCode) => calledClient(trackCode),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('1688-deliveries');
            },
        },
    );

    return {
        mutate,
        isLoading,
    };
};
